import { ListItemButton, ListItemButtonProps } from '@mui/material'
import { ReactNode } from 'react'
import { useClipboard } from '../hooks/clipboard'

export interface CopyableListItemButtonProps extends Omit<ListItemButtonProps, 'children'> {
  children: ReactNode
  copyText: string
}

export default function CopyableListItemButton({
  children,
  copyText,
  onClick,
  style,
  ...props
}: CopyableListItemButtonProps) {
  const { copyToClipboard } = useClipboard()

  const handleClick: ListItemButtonProps['onClick'] = (event) => {
    onClick?.(event)

    if (
      !copyText ||
      event.defaultPrevented ||
      !(event.target instanceof Node) ||
      !event.currentTarget.contains(event.target) ||
      (event.target instanceof Element && event.target.closest('.MuiListItemSecondaryAction-root'))
    ) {
      return
    }

    void copyToClipboard(copyText)
  }

  return (
    <ListItemButton
      {...props}
      style={copyText ? { ...style, cursor: 'copy' } : style}
      onClick={handleClick}
    >
      {children}
    </ListItemButton>
  )
}
